import { useState } from "react";
import Category from "./section/Category";
import ViolationRegister from "./section/ViolationRegister";

export default function Insert() {
    const [step, setStep] = useState(0);

    const [formData, setFormData] = useState({
        evlIdx: "",
    });

    const clearStepData = (idx) => {
        setFormData((prev) => {
            const next = { ...prev };

            switch (idx) {
                case 0:
                    next.evlIdx = "";
                    break;
                default:
                    break;
            }

            return next;
        });
    };

    const handlePrevStep = (currentStep) => {
        clearStepData(currentStep);
        if (currentStep - 1 >= 0) {
            clearStepData(currentStep - 1);
        }
        setStep(currentStep - 1);
    };

    return (
        <nav>
            {step === 0 && (
                <Category
                    value={formData.evlIdx}
                    onChange={(v) =>
                        setFormData((prev) => ({
                            ...prev,
                            evlIdx: String(v),
                        }))
                    }
                    onPrev={() => {
                        setFormData((prev) => ({ ...prev, evlIdx: "" }));
                    }}
                    onNext={() => setStep(1)}
                />
            )}

            {step === 1 && (
                <ViolationRegister
                    personType={formData.evlIdx}
                    onPrev={() => handlePrevStep(1)}
                />
            )}
        </nav>
    );
}